// extracted by mini-css-extract-plugin
export var quantityInput = "_gl-0";